import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {AccountType} from "../entity/account.type";
import {Http} from "@angular/http";
import { URLSearchParams } from '@angular/http';

@Injectable()
export class AvailableAccountTypesService {

    private apiUrl = '/api/backoffice/account-types';

    constructor(private http: Http) {

    }

    getAvailableAccountsTypes(customerId: number): Observable<AccountType[]> {
        let params = new URLSearchParams();
        params.set('clientId',String(customerId));
        return this.http.get(this.apiUrl,{search:params}).map(response => response.json());
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/service/available-account-types.service.ts